// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"228":"025cba76c8381279","2888":"1995bd3fc100a7de"}[chunkId] + ".css";
};